/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.SendELinxResponse | undefined,
  SendPaylink: (params: vp.SendELinxRequest) => void,
  reset: () => void,
  embedUrlAsync: (params: vp.SendELinxRequest) => Promise<vp.SendELinxResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostSendPaylink: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldSendPaylink, setShouldSendPaylink] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.SendELinxRequest>({
    SenderName: '',
    ReceiverName: '',
    ReceiverEmailAddress: '',
    IframeKey: '',
    InvoiceNumber: '',
    Note: '',
    ClientReferenceNumber: '',
    SendEmail: false,
  });
  const [response, setResponse] = useState<vp.SendELinxResponse>();

  useEffect(() => {
    if (!shouldSendPaylink) return () => {};

    const PostSendPaylink = async () => {
      setDataFetchingInfo(true, 'sending eLinx', 'fullScreen');
      const res = await api.postSendPaylink(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldSendPaylink) void PostSendPaylink();
    setShouldSendPaylink(false);
    return () => {
      source.cancel();
    };
  }, [shouldSendPaylink]);

  return [
    response,
    (_params: vp.SendELinxRequest) => {
      setParams(_params);
      setShouldSendPaylink(true);
    },
    () => {
      setResponse(undefined);
      setShouldSendPaylink(false);
    },
    (_params: vp.SendELinxRequest) => api.postSendPaylink(_params, source),
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostSendPaylink);
